// Archivo de compatibilidad para variables de entorno
// Soporta tanto Vite (import.meta.env.VITE_*) como CRA (process.env.REACT_APP_*)

const getEnv = (viteKey: string, reactKey: string): string => {
  // Primero intenta Vite
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const viteValue = (import.meta.env as Record<string, string>)[viteKey]
    if (viteValue !== undefined) return viteValue
  }

  // Fallback a process.env (CRA)
  if (typeof process !== 'undefined' && process.env) {
    const reactValue = (process.env as Record<string, string>)[reactKey]
    if (reactValue !== undefined) return reactValue
  }

  return ''
}

export const env = {
  API_URL: getEnv('VITE_API_URL', 'REACT_APP_API_URL'),
  WMS_SUF: getEnv('VITE_WMS_SUF', 'REACT_APP_WMS_SUF'),
  EOS_URL: getEnv('VITE_EOS_URL', 'REACT_APP_EOS_URL'),
  EOS_URI: getEnv('VITE_EOS_URI', 'REACT_APP_EOS_URI'),
  EOS_CLIENT_ID: getEnv('VITE_EOS_CLIENT_ID', 'REACT_APP_EOS_CLIENT_ID'),
  EOS_TENANT: getEnv('VITE_EOS_TENANT', 'REACT_APP_EOS_TENANT'),
}
